import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MdButtonModule, MdTooltipModule} from '@angular/material';
import {FileUploadModule} from 'ng2-file-upload';
import {CustomFormsModule} from 'ng2-validation';
import {AutoCompleteModule, CalendarModule} from 'primeng/primeng';
import {SharedModule} from '../../shared/shared.module';
import {BookingHeaderModule} from '../booking-header/booking-header.module';
import {AddInterpretersModule} from './add-interpreters/add-interpreters.module';
import {BookingFormComponent} from './booking-form.component';

@NgModule({
  declarations: [BookingFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    CustomFormsModule,
    MdButtonModule,
    MdTooltipModule,
    AutoCompleteModule,
    CalendarModule,
    FileUploadModule,
    SharedModule,
    BookingHeaderModule,
    AddInterpretersModule,
  ],
})
export class BookingFormModule {}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-form/booking-form.module.ts